import { Helmet } from "react-helmet";
import React, { Component } from "react";
import "../../styles/assets/assets.scss";
import { Button, FormControl } from "react-bootstrap";
import TemperatureAlertFilter from "../commoncomponents/TemperatureAlertFilter";
import AssetTable from "./assetTable";
import { encodeQueryData, apiHost } from "../../api/apiClient";
import axios from "axios";
import QRCode from "qrcode";
import queryString from "query-string";
import Layout from "../../Layout/layout";
import visionTrakLogo from "../../Assets/visiontrak-logo-colored.png";
import { connect } from "react-redux";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { Link } from "react-router-dom";

class Assets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetList: [],
      searchText: "",
      customerStatusFilter: "active",
      customerStatusCounts: [],
      tempAlertFilter: "All",
      tempAlertEnabled: true,
      tempAlertDisabled: true,
      sortKey: "customerName",
      sortDirection: "asc",
      pageNumber: 1,
      pageSize: 100,
      totalItems: 0,
      totalPages: 1,
      qrModalOpen: false,
      qrAsset: null,
      qrDataUrl: "",
      qrUrl: "",
      uatEntryUrl: "",
    };
    this.customerId = "";
    this.searchTimer = null;
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    this.customerId = values.customerId || "";
    this.getAssets();
    this.getCustomerStatusCounts();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      const values = queryString.parse(this.props.location.search);
      this.customerId = values.customerId || "";
      this.setState({
        pageNumber: 1,
        sortKey: this.customerId ? "name" : "customerName",
        sortDirection: "asc",
      }, () => {
        this.getAssets();
        this.getCustomerStatusCounts();
      });
    }
  }

  getAssets = async () => {
    const query = encodeQueryData(this.setAssetsQueryObject());
    const url = `${apiHost}/api/Assets/AllAssets?${query}`;

    this.props.setLoadingPageAction(true);
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      const pagination = response.headers.pagination
        ? JSON.parse(response.headers.pagination)
        : {};

      this.setState({
        assetList: response.data || [],
        totalItems: pagination.totalItems || 0,
        totalPages: pagination.totalPages || 1,
        pageNumber: pagination.currentPage || this.state.pageNumber,
      });
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);
    }
  };

  setAssetsQueryObject = () => {
    let data = {};
    data.customerId = this.customerId;
    data.SearchString = this.state.searchText;
    data.CustomerStatusFilter = this.state.customerStatusFilter;
    data.PageSize = this.state.pageSize;
    data.PageNumber = this.state.pageNumber;
    data.SortDirection = this.state.sortDirection === "desc" ? "des" : "asc";
    data.SortString = this.getApiSortString(this.state.sortKey);
    data.TempAlertFilter = this.state.tempAlertFilter;
    data.TempAlertEnabled = this.state.tempAlertEnabled;
    data.TempAlertDisabled = this.state.tempAlertDisabled;
    return data;
  };

  handleSearch = (searchText) => {
    this.setState({ searchText, pageNumber: 1 }, () => {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.getAssets();
        this.getCustomerStatusCounts();
      }, 300);
    });
  };

  handleCustomerStatusFilter = (customerStatusFilter) => {
    this.setState({ customerStatusFilter, pageNumber: 1 }, () => this.getAssets());
  };

  handleSort = (sortKey) => {
    this.setState((prevState) => ({
      sortKey,
      sortDirection:
        prevState.sortKey === sortKey && prevState.sortDirection === "asc"
          ? "desc"
          : "asc",
      pageNumber: 1,
    }), () => this.getAssets());
  };

  handlePageSize = (pageSize) => {
    this.setState({ pageSize: parseInt(pageSize), pageNumber: 1 }, () => this.getAssets());
  };

  handlePageChange = (pageNumber) => {
    const nextPage = Math.max(1, Math.min(pageNumber, this.state.totalPages || 1));
    this.setState({ pageNumber: nextPage }, () => this.getAssets());
  };

  handleTempAlertFilter = (filterData) => {
    this.setState({
      tempAlertFilter: filterData.filterType,
      tempAlertEnabled: filterData.enabledChecked,
      tempAlertDisabled: filterData.disabledChecked,
      pageNumber: 1,
    }, () => {
      this.getAssets();
      this.getCustomerStatusCounts();
    });
  };

  handleCreateNew = () => {
    const values = queryString.parse(this.props.location.search);
    if (values.customerName) {
      this.props.history.push(
        `/createAsset?selectedAsset=${encodeURIComponent(values.customerName)}&customerId=${encodeURIComponent(values.customerId)}`
      );
    } else {
      this.props.history.push("/createAsset");
    }
  };

  loadImage = (src) => new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });

  getQrLabelDataUrl = async (asset, qrUrl) => {
    const qrDataUrl = await QRCode.toDataURL(qrUrl, {
      errorCorrectionLevel: "M",
      margin: 1,
      width: 520,
      color: {
        dark: "#000000",
        light: "#ffffff",
      },
    });

    const qrImage = await this.loadImage(qrDataUrl);
    const logoImage = await this.loadImage(visionTrakLogo);
    const canvas = document.createElement("canvas");
    canvas.width = 1100;
    canvas.height = 1450;
    const ctx = canvas.getContext("2d");

    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.textAlign = "center";
    const logoWidth = 440;
    const logoHeight = (logoImage.height / logoImage.width) * logoWidth;
    ctx.drawImage(logoImage, (canvas.width - logoWidth) / 2, 80, logoWidth, logoHeight);

    ctx.fillStyle = "#1c2430";
    ctx.font = "700 66px Arial, sans-serif";
    ctx.fillText(asset.name || "Asset QR Code", canvas.width / 2, 275);

    if (asset.friendlyName) {
      ctx.fillStyle = "#697386";
      ctx.font = "400 38px Arial, sans-serif";
      ctx.fillText(asset.friendlyName, canvas.width / 2, 335);
    }

    ctx.fillStyle = "#4b5565";
    ctx.font = "400 30px Arial, sans-serif";
    ctx.fillText(`Asset ID: ${asset.id}`, canvas.width / 2, asset.friendlyName ? 400 : 345);

    const qrSize = 700;
    ctx.drawImage(qrImage, (canvas.width - qrSize) / 2, 485, qrSize, qrSize);

    ctx.fillStyle = "#4b5565";
    ctx.font = "400 32px Arial, sans-serif";
    ctx.fillText("Scan for driver pre-start and post-trip workflow", canvas.width / 2, 1265);

    ctx.strokeStyle = "#d5dce8";
    ctx.lineWidth = 3;
    ctx.strokeRect(28, 28, canvas.width - 56, canvas.height - 56);

    return canvas.toDataURL("image/png");
  };

  handleOpenQr = async (asset) => {
    if (!asset || !asset.id) {
      return;
    }

    this.props.setLoadingPageAction(true);
    try {
      const response = await axios.post(
        `${apiHost}/api/Assets/${asset.id}/QrToken`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      const data = response.data || {};
      const qrAsset = { ...asset, qrToken: data.qrToken || asset.qrToken };
      if (data.qrToken) {
        this.setState((prevState) => ({
          assetList: prevState.assetList.map((row) =>
            row.id === asset.id ? { ...row, qrToken: data.qrToken } : row
          ),
        }));
      }

      const qrUrl = data.url || `https://vttoolsuser-assettrak.visiontrak.com.au/Checks/index.php?t=${encodeURIComponent(qrAsset.qrToken)}`;
      const qrDataUrl = await this.getQrLabelDataUrl(qrAsset, qrUrl);
      this.setState({
        qrModalOpen: true,
        qrAsset,
        qrDataUrl,
        qrUrl,
        uatEntryUrl: data.uatEntryUrl || "",
      });
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
    } finally {
      this.props.setLoadingPageAction(false);
    }
  };

  handleCloseQrModal = () => {
    this.setState({
      qrModalOpen: false,
      qrAsset: null,
      qrDataUrl: "",
      qrUrl: "",
      uatEntryUrl: "",
    });
  };

  handleDownloadQr = () => {
    const { qrAsset, qrDataUrl } = this.state;
    if (!qrDataUrl || !qrAsset) {
      return;
    }

    const link = document.createElement("a");
    const fileName = String(qrAsset.name || "asset")
      .replace(/[^a-z0-9-_]+/gi, "-")
      .replace(/^-+|-+$/g, "") || "asset";
    link.href = qrDataUrl;
    link.download = `${fileName}-QR.png`;
    link.click();
  };

  dataUrlToBlob = (dataUrl) => {
    const parts = dataUrl.split(",");
    const mimeMatch = parts[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/png";
    const binary = atob(parts[1]);
    const length = binary.length;
    const bytes = new Uint8Array(length);

    for (let index = 0; index < length; index += 1) {
      bytes[index] = binary.charCodeAt(index);
    }

    return new Blob([bytes], { type: mime });
  };

  handlePrintQr = () => {
    const { qrAsset, qrDataUrl } = this.state;
    if (!qrDataUrl) {
      return;
    }

    const imageUrl = URL.createObjectURL(this.dataUrlToBlob(qrDataUrl));
    const iframe = document.createElement("iframe");
    iframe.title = "Asset QR Code Print";
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "1px";
    iframe.style.height = "1px";
    iframe.style.border = "0";
    iframe.style.opacity = "0";

    const escapedTitle = `${qrAsset && qrAsset.name ? qrAsset.name : "Asset"} - QR Code`
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");

    const cleanup = () => {
      setTimeout(() => {
        URL.revokeObjectURL(imageUrl);
        if (iframe.parentNode) {
          iframe.parentNode.removeChild(iframe);
        }
      }, 1000);
    };

    document.body.appendChild(iframe);
    const printDocument = iframe.contentWindow.document;
    printDocument.open();
    printDocument.write(`
      <html>
        <head>
          <title>${escapedTitle}</title>
          <style>
            html, body { background: #fff; margin: 0; min-height: 100%; }
            body { display: flex; align-items: center; justify-content: center; padding: 4mm; }
            img { display: block; max-width: 200mm; width: 100%; height: auto; }
            @page { margin: 4mm; }
            @media print { body { display: block; padding: 0; text-align: center; } img { margin: 0 auto; max-width: 200mm; width: 100%; } }
          </style>
        </head>
        <body>
          <img id="qrLabel" src="${imageUrl}" alt="Asset QR Code" />
        </body>
      </html>
    `);
    printDocument.close();

    const printImage = printDocument.getElementById("qrLabel");
    const triggerPrint = () => {
      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        cleanup();
      }, 250);
    };

    if (printImage.complete) {
      triggerPrint();
    } else {
      printImage.onload = triggerPrint;
      printImage.onerror = cleanup;
    }
  };

  handleTestQr = () => {
    const href = this.state.uatEntryUrl || this.state.qrUrl;
    if (!href) return;

    const parentWindow = window.opener && !window.opener.closed ? window.opener : window;
    const testTab = parentWindow.open(href, "_blank");
    if (testTab) {
      testTab.focus();
      return;
    }

    window.open(href, "_blank");
  };

  getStatusCounts = () => {
    return this.state.customerStatusCounts.reduce((counts, item) => {
      counts[item.status] = item.count;
      counts.all += item.count;
      return counts;
    }, { all: 0, active: 0, disabled: 0 });
  };

  getCustomerStatusCounts = async () => {
    const query = encodeQueryData({
      customerId: this.customerId,
      SearchString: this.state.searchText,
      TempAlertFilter: this.state.tempAlertFilter,
      TempAlertEnabled: this.state.tempAlertEnabled,
      TempAlertDisabled: this.state.tempAlertDisabled,
    });
    const url = `${apiHost}/api/Assets/CustomerStatusCounts?${query}`;

    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({ customerStatusCounts: response.data || [] });
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
    }
  };

  getApiSortString = (sortKey) => {
    const sortMap = {
      depotName: "depot",
      customerName: "customer",
      friendlyName: "name",
      profile: "profile",
      dbUpdated: "updated",
    };

    return sortMap[sortKey] || sortKey || (this.customerId ? "name" : "customer");
  };

  render() {
    const values = queryString.parse(this.props.location.search);
    const {
      searchText,
      customerStatusFilter,
      sortKey,
      sortDirection,
      pageNumber,
      pageSize,
      totalItems,
      totalPages,
      assetList,
      qrAsset,
      qrDataUrl,
      qrModalOpen,
    } = this.state;
    const statusCounts = this.getStatusCounts();
    const customerStatusFilters = [
      { key: "all", label: "All", count: statusCounts.all },
      { key: "active", label: "Active", count: statusCounts.active },
      { key: "disabled", label: "Disabled", count: statusCounts.disabled },
    ];
    const entryStart = totalItems === 0 ? 0 : (pageNumber - 1) * pageSize + 1;
    const entryEnd = Math.min(pageNumber * pageSize, totalItems);
    const pageSizes = [50, 100, 200];
    const isSystemAdmin = localStorage.getItem("role") === "SystemAdmin";

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Assets</title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper asset-page">
              <div className="asset-page-header">
                <div>
                  <h2>Assets</h2>
                  <p>Manage fleet assets, customer ownership, devices, features and reporting status.</p>
                  {values.customerId && (
                    <Link
                      className="asset-filter-pill"
                      onClick={() => localStorage.removeItem("customer")}
                      to="/assets"
                    >
                      <i className="fa fa-times"></i>
                      {values.customerName}
                    </Link>
                  )}
                </div>
                {localStorage.getItem("role") === "SystemAdmin" && (
                  <Button className="asset-create-button" variant="primary" onClick={() => this.handleCreateNew()}>
                    <i className="fa fa-plus"></i>
                    Create new
                  </Button>
                )}
              </div>

              <div className="asset-toolbar">
                <div className="asset-search">
                  <i className="fa fa-search"></i>
                  <FormControl
                    aria-label="Search assets"
                    onChange={(e) => this.handleSearch(e.target.value)}
                    placeholder="Search assets, customers, depots, tags or status"
                    value={searchText}
                  />
                  {searchText && (
                    <button onClick={() => this.handleSearch("")} type="button">
                      <i className="fa fa-times"></i>
                    </button>
                  )}
                </div>
                <TemperatureAlertFilter onFilterChange={this.handleTempAlertFilter} />
                {isSystemAdmin && (
                  <div className="asset-status-filter" aria-label="Active customer filter">
                    <span>Active customer filter</span>
                    <div>
                      {customerStatusFilters.map((filter) => (
                        <button
                          className={customerStatusFilter === filter.key ? "active" : ""}
                          key={filter.key}
                          onClick={() => this.handleCustomerStatusFilter(filter.key)}
                          type="button"
                        >
                          {filter.label}
                          <strong>{filter.count}</strong>
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="asset-table-shell">
                <AssetTable
                  assets={assetList}
                  onOpenQr={this.handleOpenQr}
                  onSort={this.handleSort}
                  sortDirection={sortDirection}
                  sortKey={sortKey}
                />
              </div>
              <div className="asset-pagination">
                <div>
                  Showing <strong>{entryStart}</strong> to <strong>{entryEnd}</strong> of{" "}
                  <strong>{totalItems}</strong> assets
                </div>
                <div className="asset-pagination-actions">
                  <label>
                    Rows
                    <select value={pageSize} onChange={(e) => this.handlePageSize(e.target.value)}>
                      {pageSizes.map((size) => (
                        <option key={size} value={size}>{size}</option>
                      ))}
                    </select>
                  </label>
                  <button
                    disabled={pageNumber <= 1}
                    onClick={() => this.handlePageChange(pageNumber - 1)}
                    type="button"
                  >
                    Previous
                  </button>
                  <span>
                    Page <strong>{pageNumber}</strong> of <strong>{totalPages}</strong>
                  </span>
                  <button
                    disabled={pageNumber >= totalPages}
                    onClick={() => this.handlePageChange(pageNumber + 1)}
                    type="button"
                  >
                    Next
                  </button>
                </div>
              </div>
              {qrModalOpen && (
                <div className="asset-qr-modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="assetQrModalTitle">
                  <div className="asset-qr-modal">
                    <div className="asset-qr-modal-header">
                      <h3 id="assetQrModalTitle">Asset QR Code</h3>
                      <button onClick={this.handleCloseQrModal} type="button" aria-label="Close QR modal">
                        <i className="fa fa-times"></i>
                      </button>
                    </div>
                    <div className="asset-qr-modal-body">
                      {qrDataUrl && (
                        <img
                          alt={`${qrAsset && qrAsset.name ? qrAsset.name : "Asset"} QR code`}
                          className="asset-qr-label-preview"
                          src={qrDataUrl}
                        />
                      )}
                    </div>
                    <div className="asset-qr-modal-actions">
                      <Button variant="primary" onClick={this.handleDownloadQr}>
                        Download PNG
                      </Button>
                      <Button variant="secondary" onClick={this.handlePrintQr}>
                        Print
                      </Button>
                      <Button variant="outline-primary" onClick={this.handleTestQr}>
                        Test
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  customerName: state.customerName,
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Assets);
